import { useState, createContext } from 'react';
import type { Dispatch, SetStateAction, ReactNode } from 'react';

export const BannerContext = createContext<{
  setBanners?: Dispatch<SetStateAction<{ content: ReactNode }[]>>;
}>({});

const BannerProvider = (props: { children: ReactNode }) => {
  const { children } = props;
  const [banners, setBanners] = useState<{ content: ReactNode }[]>([]);

  return (
    <BannerContext.Provider value={{ setBanners }}>
      <>
        {banners.map((banner) => banner.content)}
        {children}
      </>
    </BannerContext.Provider>
  );
};

export default BannerProvider;
